import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { buildUrl } from '../../helpers/links';
import { sanitizeSlug } from '../../helpers/sanitizeSlug';
import styles from './navigation.module.scss';
export const LiLevel1 = ({ children, navigationItem })=>{
    const pathname = usePathname();
    const isActive = sanitizeSlug(buildUrl(navigationItem.link) || '') === sanitizeSlug(pathname);
    return /*#__PURE__*/ _jsx("li", {
        className: classNames(styles['nav-group-list-item'], isActive && styles['nav-group-list-item-active']),
        children: children
    });
};

//# sourceMappingURL=li-level-1.js.map